import React from "react"
import connect from "./connect"
import env from "../../config/env"
import {LoadingIconPrevNextPageContainer} from "./components"
import LoadingIconContainer from "../loadingIconContainer"

const {REACT_APP_BLOB_STORAGE_PATH} = env

export interface SpinnerProps {
    realm: string
    ariaValueText: string
    testid: string
    altText: string
}

export const Spinner = ({realm, ariaValueText, testid, altText}: SpinnerProps) => (
    <LoadingIconContainer ariaValueText={ariaValueText} data-testid={testid} altText={altText}>
        <img src={`${REACT_APP_BLOB_STORAGE_PATH}/icons/shared/brand/${realm}/loader.gif`} alt={altText} />
    </LoadingIconContainer>
)

export const PrevNextSpinner = ({realm, ariaValueText, testid, altText}: SpinnerProps) => (
    <LoadingIconPrevNextPageContainer
        role="progressbar"
        aria-valuetext={ariaValueText}
        data-testid={testid}
        aria-label={altText}
    >
        <img src={`${REACT_APP_BLOB_STORAGE_PATH}/icons/shared/brand/${realm}/loader.gif`} alt={altText} />
    </LoadingIconPrevNextPageContainer>
)
const ConnectSpinner = connect(Spinner)
const ConnectPrevNextSpinner = connect(PrevNextSpinner)

export {ConnectSpinner, ConnectPrevNextSpinner}
